import { render, staticRenderFns } from "./bodyComposition.vue?vue&type=template&id=3b51322a&scoped=true&"
import script from "./bodyComposition.vue?vue&type=script&lang=js&"
export * from "./bodyComposition.vue?vue&type=script&lang=js&"
import style0 from "./bodyComposition.vue?vue&type=style&index=0&id=3b51322a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b51322a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\source\\200xth\\xth2.web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3b51322a')) {
      api.createRecord('3b51322a', component.options)
    } else {
      api.reload('3b51322a', component.options)
    }
    module.hot.accept("./bodyComposition.vue?vue&type=template&id=3b51322a&scoped=true&", function () {
      api.rerender('3b51322a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/library/bodyComposition.vue"
export default component.exports